import React, { createContext } from 'react';
import localization from '../data/localization/en-US.json';

const initialState = localization;
const LocalizationContext = createContext(initialState);
const { Provider } = LocalizationContext;

const LocalizationProvider = ({ children }) => {
  return <Provider value={initialState}>{children}</Provider>;
};

export { LocalizationContext, LocalizationProvider };
